import './index.css';
import { useRef, useCallback, useLayoutEffect } from 'react';

const useTableResize = ({ fontLoaded, tableRef }) => {
    const handlers = useRef([]);
    const prevWidth = useRef(null);
    const subscribeResizeHandler = useCallback((sub, index) => {
        if (index) {
            handlers.current.splice(index, 0, sub);
        }
        else {
            handlers.current.push(sub);
        }
    }, []);
    const unsubscribeResizeHandler = useCallback((sub) => {
        handlers.current = handlers.current.filter((handler) => handler !== sub);
    }, []);
    useLayoutEffect(() => {
        if (fontLoaded && tableRef.current) {
            const observer = new ResizeObserver((entries) => {
                const entry = entries[0];
                if (entry.borderBoxSize[0].inlineSize !== prevWidth.current) {
                    handlers.current.forEach((handler) => handler());
                    prevWidth.current = entry.borderBoxSize[0].inlineSize;
                }
            });
            observer.observe(tableRef.current);
            return () => {
                observer.disconnect();
            };
        }
        return void 0;
        // eslint-disable-next-line disable-autofix/react-hooks/exhaustive-deps
    }, [fontLoaded, tableRef.current]);
    return { subscribeResizeHandler, unsubscribeResizeHandler };
};

export { useTableResize };
//# sourceMappingURL=useTableResize.js.map
